import * as React from 'react'
import styled from 'styled-components'

import * as model from '@owl-nest/models'
import * as layout from '../layout'
import { styles as S } from '@ulule/owl-kit-components/next'
import { t } from '@owl-nest/localize'

import * as projectModel from '../../../models/project'

const Coach = styled(layout.Coach)`
  ${S.modal.Body} {
    display: flex;
    flex-direction: column;
  }
  ${S.button.Button} {
    margin-top: 15px;
  }
`

type AcceptedProps = {
  initialOpen: boolean
  project: projectModel.Project
  markStepDone: () => Promise<void>
}

export function Accepted({
  project,
  markStepDone,
  initialOpen,
}: AcceptedProps): React.ReactElement<AcceptedProps> | null {
  const manager = project.manager || project.default_manager
  const [open, setIsOpen] = React.useState(initialOpen)

  if (manager === undefined) {
    return null
  }

  const managerAvatar = model.image.getUrl(manager.avatar.versions, '128x128')

  if (!open) {
    return (
      <layout.Notification avatar={managerAvatar} onClick={goToDiscussion}>
        {t('1 new message')}
      </layout.Notification>
    )
  }

  return (
    <Coach closable={true} open={open} title={t('Ready to start?')} onClose={handleDone} avatar={managerAvatar}>
      <S.heading.XS>{t('It’s your move 🎉')}</S.heading.XS>
      <S.copy.S.regular>
        {t('Your project will happen on Ulule! %(manager)s will be your coach and has a message for you.', {
          manager: manager.name,
        })}
      </S.copy.S.regular>
      <S.button.Button kind="primary" onClick={goToDiscussion}>
        {t('Read %(manager)s’s message', {
          manager: manager.name,
        })}
      </S.button.Button>
    </Coach>
  )

  async function handleDone(): Promise<void> {
    setIsOpen(false)
    await markStepDone()
  }

  async function goToDiscussion(): Promise<void> {
    await handleDone()
    window.location.href = `/projects/${project.id}/discussion/#last-message`
  }
}
